import type { MetricDataPointInput } from "../../api/generated/graphql";

import type { WaterlyAppStateCreator } from "./waterlyAppStateCreator.type";

export type MetricDataPointInputId = MetricDataPointInput["id"];

type DirtyDataPointsState = {
  dirtyDataPoints: Record<MetricDataPointInputId, MetricDataPointInput>;
  isAutoSavePaused: boolean;
};

type DirtyDataPointsActions = {
  addDirtyDataPoint: (dirtyDataPoint: MetricDataPointInput) => void;
  removeDirtyDataPointById: (id: MetricDataPointInputId) => void;
  resetDirtyDataPoints: () => void;
  setAutoSavePaused: (paused: boolean) => void;
};

const initialState: DirtyDataPointsState = {
  dirtyDataPoints: {},
  isAutoSavePaused: false,
};

export const createDirtyDataPointsSlice: WaterlyAppStateCreator<
  DirtyDataPointsActions,
  DirtyDataPointsState
> = (set) => ({
  ...initialState,

  addDirtyDataPoint: (dirtyDataPoint: MetricDataPointInput) => {
    set(
      (s) => {
        s.dirtyDataPoints[dirtyDataPoint.id] = dirtyDataPoint;
      },
      undefined,
      "dirtyDataPoints:add",
    );
  },

  removeDirtyDataPointById: (id: MetricDataPointInputId) => {
    set(
      ({ dirtyDataPoints }) => {
        delete dirtyDataPoints[id];
      },
      undefined,
      "dirtyDataPoints:removeById",
    );
  },

  resetDirtyDataPoints: () =>
    set(
      (state) => {
        // clear the state of dirty data points manually instead of instantiating a new object
        for (const key of Object.keys(state.dirtyDataPoints)) {
          delete state.dirtyDataPoints[key as unknown as MetricDataPointInputId];
        }
      },
      undefined,
      "dirtyDataPoints:resetDirtyDataPoints",
    ),

  setAutoSavePaused: (paused: boolean) =>
    set(
      (state) => {
        state.isAutoSavePaused = paused;
      },
      undefined,
      "dirtyDataPoints:setAutoSavePaused",
    ),
});
